import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { ActivitiesService } from 'src/app/services/activities-services/activities.service';
import { SmsStatistic } from 'src/app/models/activities-model/sms-statistic.model';
import { catchError } from 'rxjs/internal/operators/catchError';
import { tap } from 'rxjs/internal/operators/tap';
import { EMPTY } from 'rxjs';

@Component({
  selector: 'app-activities-activities-dashboard',
  templateUrl: './activities-activities-dashboard.component.html',
  styleUrls: ['./activities-activities-dashboard.component.scss']
})
export class ActivitiesActivitiesDashboardComponent implements OnInit, OnDestroy {

  smsConsumptionList;
  getSmsConsumptionSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
    private snackbarService: SnackBarService,
    private activitiesService: ActivitiesService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getSmsConsumption();
  }

  private getSmsConsumption() {
    const datetimeFrom = new Date(new Date().getFullYear(), new Date().getMonth(), 1, 0, 0, 0).getTime();
    const datetimeTo = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59.999).getTime();
    this.getSmsConsumptionSubscription = this.activitiesService.getSmsConsumptionList(datetimeFrom, datetimeTo).pipe(
      tap(o => this.smsConsumptionList = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-chart-line', 'activity-page.activity', '/account', [new BRoute('account-page.account', '/account'), new BRoute('activity-page.activity')]));
  }

  ngOnDestroy() {
    if (this.getSmsConsumptionSubscription) { this.getSmsConsumptionSubscription.unsubscribe(); }
  }
}
